export const ASSESSMENT_INDEX = 'ASSESSMENT_INDEX';
export const ASSESSMENT_CERTIFICATE = 'ASSESSMENT_CERTIFICATE';
export const ASSESSMENT_LOADING = 'ASSESSMENT_LOADING';
export const ASSESSMENT_RESET = 'ASSESSMENT_RESET';
